import { Box, Button, ButtonProps, Dialog, DialogContent, DialogTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'
import useDialog from '../../hooks/useDialog'
import { Add } from '@mui/icons-material'
import DeviceInstallProjectCreation from './DeviceInstallProjectCreation'
import { Project } from '../../types'

export interface CreateProjectButtonProps extends Omit<ButtonProps, 'onClick' | 'children'> {
  afterCreate?: (project: Project) => void
}

export default function CreateProjectButton({ afterCreate, ...props }: CreateProjectButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The dialog state.
   */
  const { open, openDialog, closeDialog } = useDialog()

  function handleAfterCreate(project: Project) {
    if (afterCreate) {
      afterCreate(project)
    }
    closeDialog()
  }

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<Add />}
        {...props}
        onClick={openDialog}
      >
        {t('newProject')}
      </Button>

      <Dialog open={open} maxWidth="sm" fullWidth onClose={closeDialog}>
        <DialogTitle>{t('createNewProject')}</DialogTitle>
        <DialogContent>
          <Box mt={2}>
            <DeviceInstallProjectCreation afterCreate={handleAfterCreate} onCancel={closeDialog} />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}
